import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import AlertType from "@app/model/alert/AlertType";
import PriceComparisonAlertPage from "@app/site/secured/alert/page/PriceComparisonAlertPage";
import PageHeader from "@app/component/page/PageHeader";
import CompetitorsPriceRateAlertPage from "@app/site/secured/alert/page/CompetitorsPriceRateAlertPage";


const AlertPage: React.FunctionComponent<{ isCopy?: boolean }> = ({isCopy = false}) => {

    const {alertId, alertType} = useParams();
    const navigate = useNavigate();

    if (!alertType || !Object.values(AlertType).includes(alertType as AlertType)) navigate('/secured/dashboards');

    return <>
        <PageHeader link="/secured/alerts">
            {isCopy && 'Duplicate Alert'}
            {!isCopy && (!!alertId ? 'Edit Alert' : 'Create Alert')}
        </PageHeader>
        <main>
            {alertType === AlertType.PRICE_COMPARISON && <PriceComparisonAlertPage alertId={!!alertId ? parseInt(alertId) : undefined} isCopy={isCopy}/>}
            {alertType === AlertType.COMPETITORS_PRICE_RATE && <CompetitorsPriceRateAlertPage alertId={!!alertId ? parseInt(alertId) : undefined} isCopy={isCopy}/>}
        </main>
    </>

}


export default AlertPage;
